import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

type ImageAreaProps = {
  src: string;
  imgOgCompText: string;
  scoreText?: string;
  sizeAndContainerText: string;
  paddingTopPercentage: string;
  priority?: boolean;
};

const AVIFSpeedQualityTestImageArea = ({
  src,
  imgOgCompText,
  sizeAndContainerText,
  scoreText = '',
  paddingTopPercentage,
  priority = false,
}: ImageAreaProps) => {
  return (
    <AVIFSpeedQualityTestImageAreaContainer
      paddingTopPercentage={paddingTopPercentage}
    >
      <div className="top-area">
        <ImgBackgroundWrapper isNormalUse>
          <Image
            src={src}
            alt=""
            objectFit="cover"
            layout="fill"
            priority={priority}
          />
        </ImgBackgroundWrapper>
      </div>
      <div className="bottom-area">
        <div className="upper-w">
          <span className="o-c-w">{imgOgCompText}</span>
          <span className="s-c-w">{sizeAndContainerText}</span>
        </div>
        <div className="below-w">{scoreText}</div>
      </div>
    </AVIFSpeedQualityTestImageAreaContainer>
  );
};

export default AVIFSpeedQualityTestImageArea;

const AVIFSpeedQualityTestImageAreaContainer = styled.div<{
  paddingTopPercentage: string;
}>`
  border: 1px solid #f2f2f2;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 12px;
  width: 100%;
  & + & {
    margin-left: 18px;
  }

  .top-area {
    width: 100%;
    padding-top: ${({ paddingTopPercentage }) => paddingTopPercentage};
    position: relative;
  }
  .bottom-area {
    padding: 8px;
  }

  .o-c-w {
    font-weight: 500;
  }
  .s-c-w {
    font-weight: 700;
  }
  .upper-w {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .below-w {
    margin-top: 12px;
    font-weight: 500;
  }

  @media screen and (max-width: 904px) {
    margin: 16px 0;
  }

  @media screen and (max-width: 904px) {
    margin: 8px 0;
    & + & {
      margin-left: 0;
    }
  }
`;
